<script>
	import Footer from "./components/Footer.svelte"
	import Header from './components/Header.svelte'
	import Main from "./components/Main.svelte"
	import ContentForm from "./components/ContentForm.svelte"
</script>

<svelte:head>
	<title>Sergio Filoth</title>
	<meta name="description" content="Pagína web personal de Sergio Filoth, desarrollador web Front-end con 5 años de experiencia, ahora llevemos tu marca a la web">
</svelte:head>

<Header />
<Main />
<ContentForm />
<Footer />